import { IncentiveCategory } from '@varo/graphql-schema-types';
import IncentiveHowItWorksScreen from 'features/incentive/screens/IncentiveHowItWorksScreen/IncentiveHowItWorksScreen';

export default function IncentiveHowItWorksPage() {
  return (
    <IncentiveHowItWorksScreen incentiveType={IncentiveCategory.Sweepstakes} />
  );
}
